import React from 'react';
import { GET_APP_OVERVIEW } from './apps.graphql';
import { useQuery } from '@apollo/client';
import { AppTable } from './AppTable';
import { Alert, Box, Button, Typography } from '@mui/material';
import { StyledPaper } from '../theme';

/** How wide the app pages grow, centred in what is left. The grid's columns all fit well before it; wider just spreads them out. */
export const APP_PAGE_MAX_WIDTH = 1400;

export function Overview() {
  const { data, error, refetch } = useQuery(GET_APP_OVERVIEW, { fetchPolicy: 'cache-and-network' });
  return (
    // The box rather than the paper is centred, so the paper keeps its own right margin on a narrow screen.
    <Box sx={{ maxWidth: APP_PAGE_MAX_WIDTH, mx: 'auto' }}>
      <StyledPaper>
        <Typography variant="h5" gutterBottom>
          Applikasjoner
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Alle applikasjoner utviklet for Byggforskserien og Våtromsnormen
        </Typography>
        {error && <AppsError onRetry={() => refetch()} />}
        {!error && <AppTable apps={data?.appOverview?.filter((x) => !!x) ?? []} loading={!data} />}
      </StyledPaper>
    </Box>
  );
}

/** The overview needs the apps service for names and to group versions; say so when it is down. */
export function AppsError({ onRetry }: { onRetry(): void }) {
  return (
    <Alert
      severity="error"
      sx={{ mt: 2 }}
      action={
        <Button color="inherit" size="small" onClick={onRetry}>
          Prøv igjen
        </Button>
      }>
      Kunne ikke hente applikasjonene. Applikasjonstjenesten svarer ikke.
    </Alert>
  );
}
